import React, { useEffect, useImperativeHandle, useState, useRef, useMemo } from 'react';
import { Table, Button, Space, Typography, Modal, Form, Popconfirm, message, Input, Tooltip } from '@drip/drip-design';
import classnames from 'classnames';
import { PlusOutlined, DownloadOutlined, UploadOutlined, CheckOutlined } from '@drip/drip-design-icons';
import Container from '@/components/container';
import goodsGroupList from '@/apis/goodsGroup/list';
import goodsGroupDel from '@/apis/goodsGroup/del';
import goodsGroupDownload from '@/apis/goodsGroup/download';
import queryString from 'query-string';
import env from '@/env';
import fileUploadList from '@/apis/goodsGroup/fileUploadList';
import goodsGroupCreate from '@/apis/goodsGroup/create';
import UploadFile from '@/components/upload-file';
import CommonLog from '@/components/component-log';
import history from '@/history';

import apis from '@/components/batch-operate/apis';
import './index.less';

const { Title } = Typography;

export default function GroupProduct() {
  const [conditions, setConditions] = useState({ pageSize: 10, currentPage: 1 });
  const [data, setData] = useState({ loading: true, list: [], currentPage: 1, pageSize: 10, totalCount: 0 });

  const parsedQuery = useMemo(() => {
    return queryString.parse(location.search);
  }, []);

  useEffect(() => {
    if (parsedQuery.create) {
      return instanceModalOfEditGroup.current.show();
    }

    if (parsedQuery.code && parsedQuery.editable) {
      // 现在没有这个情况先不实现
    }

    if (parsedQuery.code) {
      // 现在没有这个情况先不实现
    }
  }, [parsedQuery]);

  useEffect(() => {
    setData((innerData) => {
      return { ...innerData, loading: true };
    });
    goodsGroupList(conditions).then((res) => {
      if (res?.ret === '0') setData({ ...res.data, loading: false });
      else message.error('网络异常请重试');
    });
  }, [conditions]);

  const columns = [
    {
      title: '序号',
      width: 60,
      render: (_, record, i) => i + 1 + data.pageSize * (data.currentPage - 1),
    },
    {
      title: '商品组名称',
      dataIndex: 'name',
      width: '300px',
      render(name, record) {
        let finalName = name;
        // "状态，1：处理完成，0：处理中，2：系统或数据异常导致任务结束"
        if (record.status === 1) finalName = name;
        if (record.status === 2) finalName = name + ' - 上传错误';
        if (record.status === 0) finalName = name + ' - 上传中';

        return (
          <Tooltip title={finalName}>
            <span className="ellipsis-1-line">{finalName}</span>
          </Tooltip>
        );
      },
    },
    {
      title: 'SKU数量',
      dataIndex: 'skuNum',
    },
    {
      title: '商品来源',
      dataIndex: 'source',
      render(source) {
        if (source == 1) return 'SKU上传';
        else return '规则选品';
      },
    },
    {
      title: '操作',
      width: 200,
      dataIndex: 'btn',
      render: (btns = [], record) => {
        const someBtns = {
          update() {
            return (
              <CommonLog>
                <a
                  clstag="yx_center_hzcp_1678258944439|29"
                  onClick={() => {
                    instanceModalOfEditGroup.current.show(record);
                  }}
                >
                  编辑
                </a>
              </CommonLog>
            );
          },
          del() {
            return (
              <Popconfirm
                placement="top"
                title="确认删除吗？"
                onConfirm={() => {
                  goodsGroupDel({ groupCodes: record.code }).then((res) => {
                    if (res?.ret === '0') {
                      updateList();
                      message.success('删除成功');
                    } else message.error(res?.msg || '删除出错，请重试');
                  });
                }}
                okText="确定"
                cancelText="取消"
              >
                <a>删除</a>
              </Popconfirm>
            );
          },
          download() {
            return (
              <CommonLog>
                <a
                  clstag="yx_center_hzcp_1678258944439|30"
                  target="_blank"
                  onClick={() => {
                    goodsGroupDownload({ groupCodes: record.code }).then((res) => {
                      if (res.ret === '0') {
                        message.success('下载成功，文件稍后通过鲸盘进行推送', 5);
                      } else {
                        message.success('数据下载失败请重试');
                      }
                    });
                  }}
                  rel="noreferrer"
                >
                  下载
                </a>
              </CommonLog>
            );
          },
        };
        return <Space>{btns.map((btn) => someBtns[btn]?.()).filter((item) => !!item)}</Space>;
      },
    },
  ];

  function updateList() {
    setConditions({ ...conditions });
  }

  const instanceModalOfEditGroup = useRef(null);

  return (
    <Container>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'start' }}>
        <Title level={3}>管理商品组</Title>
        <CommonLog>
          <Button
            clstag="yx_center_hzcp_1678258944439|28"
            onClick={() => instanceModalOfEditGroup.current.show()}
            type="primary"
          >
            <PlusOutlined />
            新建
          </Button>
        </CommonLog>
      </div>
      <Table
        onChange={(pagination) => {
          const { current, pageSize } = pagination;
          setConditions((innerConditions) => {
            return { ...innerConditions, currentPage: current, pageSize };
          });
        }}
        pagination={{ pageSize: data.pageSize, current: data.currentPage, total: data.totalCount }}
        loading={data.loading}
        rowKey="id"
        columns={columns}
        dataSource={data?.list || []}
      />
      <ModalOfEditGroup
        ref={instanceModalOfEditGroup}
        onClose={() => {
          history.replace(window.location.pathname);
        }}
        onSuccess={() => {
          updateList();
          message.success('商品组数据保存成功');
        }}
      />
    </Container>
  );
}

const ModalOfEditGroup = React.forwardRef(function ModalOfEditGroup({ onSuccess, onClose }, ref) {
  const [visible, setVisible] = useState(false);

  useImperativeHandle(ref, () => {
    return {
      show(formData) {
        // 创建
        if (!formData) {
          setVisible(true);
          return;
        }
        // 编辑
        const { code, name, source } = formData;
        // 首先重置右边列表的查询条件，让右侧的列表展示出来
        setConditions((conditions) => ({ ...conditions, code }));
        // 其次初始化表单，将编辑的信息设置进去
        form.setFieldsValue({
          name,
          code,
          type: source,
        });
        // 所有信息准备好之后展示表单
        setVisible(true);
      },
    };
  });

  const initialData = useMemo(
    () => ({ loading: false, totalPage: 0, pageSize: 5, currentPage: 1, totalCount: 0, list: [] }),
    []
  );

  const [form] = Form.useForm();
  // 右侧列表数据
  const [data, setData] = useState(initialData);
  // 右侧列表筛选条件
  const [conditions, setConditions] = useState({ pageSize: 5, currentPage: 1, code: undefined });

  // 是否是编辑状态
  const inEditable = conditions.code;

  useEffect(() => {
    if (!conditions.code) return setData(initialData);

    setData((innerData) => ({ ...innerData, loading: true }));
    fileUploadList({ ...conditions, groupCode: conditions.code }).then((res) => {
      if (res?.ret === '0') {
        setData({ ...res.data, loading: false });
      }
    });
  }, [conditions, initialData]);

  function onFinish(values) {
    setData((innerData) => ({ ...innerData, loading: true }));
    // bizCode
    const data = { name: values.name, type: values.type };
    if (values.code) data.code = values.code;

    goodsGroupCreate(data).then((res) => {
      const ret = res?.ret;
      if (ret === '0') {
        const code = res?.data?.code;
        if (!values.file) {
          // 在这里设置conditions去查询
          setConditions((conditions) => ({ ...conditions, code }));
          form.setFieldsValue({ file: undefined });
          onSuccess();
        } else {
          apis
            .taskStartBatch({
              bizCode: env.LONG_MISSION.PRODUCT_GROP,
              body: JSON.stringify({ code }),
              file: values.file,
            })
            .then((res) => {
              // 在这里设置conditions去查询
              setConditions((conditions) => ({ ...conditions, code }));
              form.setFieldsValue({ file: undefined });
              onSuccess();
            });
        }
      }
    });
  }

  const [_, refresh] = useState(0);

  const addType = form.getFieldValue('type') || 1;

  function handleClose() {
    setConditions({ pageSize: 5, currentPage: 1 });
    form.resetFields();
    setVisible(false);
    onClose?.();
  }

  return (
    <Modal
      maskClosable={false}
      footer={
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <Space>
            {addType === 1 && <Button onClick={handleClose}>取消</Button>}
            {addType === 1 && (
              <Button loading={data.loading} onClick={() => form.submit()} type="primary">
                确定
              </Button>
            )}
            {addType === 2 && <Button type="primary">去选品</Button>}
          </Space>
        </div>
      }
      width={1150}
      title="编辑商品组"
      onCancel={handleClose}
      visible={visible}
    >
      <div style={{ display: 'flex' }}>
        <div style={{ width: '320px', paddingRight: '20px' }}>
          <Form
            onValuesChange={(values) => {
              refresh((_) => _ + 1);
            }}
            layout="vertical"
            onFinish={onFinish}
            form={form}
          >
            <Title level={5}>设定名称及添加方式</Title>
            <Form.Item
              name="name"
              label="商品组名称"
              required
              rules={[
                { required: true, message: '商品组名称不能为空' },
                { max: 15, message: '不得超过15个字' },
              ]}
            >
              <Input placeholder="示例：爆品组，不超过15个字" />
            </Form.Item>
            <Form.Item name="type" label="商品组添加方式" required initialValue={1}>
              <AddTypes />
            </Form.Item>
            {/* 如果是编辑 */}
            {!!conditions.code && <Form.Item hidden name="code" initialValue={conditions.code} />}
            <Form.Item shouldUpdate={(oldValue, newValue) => newValue.body?.type !== oldValue.body?.type}>
              {(formInstance) => {
                if (formInstance.getFieldValue('type') !== 1) return null;
                return (
                  <div
                    style={{
                      marginTop: '-10px',
                      padding: '16px',
                      background: '#F5F5FA',
                      borderRadius: '5px',
                      position: 'relative',
                    }}
                  >
                    <Form.Item
                      name="file"
                      // 创建模式才需要必填
                      required={!inEditable}
                      rules={[{ required: !inEditable, message: '请上传文件' }]}
                    >
                      <UploadFile module={4}>
                        <span>
                          <UploadOutlined />
                          上传SKU数据
                        </span>
                      </UploadFile>
                    </Form.Item>
                    <a
                      href="https://storage.360buyimg.com/tag.pool.white/模板/%E8%B4%A7%E5%93%81%E5%88%86%E7%BB%84sku%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xls"
                      style={{ position: 'absolute', lineHeight: '32px', paddingLeft: '10px', right: 20, top: 16 }}
                      rel="noreferrer"
                    >
                      下载上传数据模板
                    </a>
                    <div style={{ marginTop: '8px', color: 'rgba(0, 0, 0, 0.45)', lineHeight: '18px' }}>
                      注：单次仅支持上传1个文件，每次上传会覆盖之前上传的货品； 必须使用模版才能上传成功
                    </div>
                  </div>
                );
              }}
            </Form.Item>
          </Form>
        </div>
        <div style={{ flexGrow: 1, paddingLeft: '20px' }}>
          <Title level={5}>已上传SKU文件</Title>
          <Table
            onChange={(pagination) => {
              const { current, pageSize } = pagination;
              setConditions((innerConditions) => {
                return { ...innerConditions, currentPage: current, pageSize };
              });
            }}
            pagination={{ pageSize: data.pageSize, current: data.currentPage, total: data.totalCount }}
            loading={data.loading}
            dataSource={data.list}
            width="100%"
            columns={[
              {
                title: '文件名称',
                width: '150px',
                dataIndex: 'fileName',
                render: (fileName) => <span className="ellipsis-1-line">{fileName}</span>,
              },
              {
                title: '上传进度',
                width: 60,
                dataIndex: 'currProgress',
                render: (_, { currProgress, fullProgress, status, msg }) => {
                  if (status === 2) return <span style={{ color: 'red' }}>{msg}</span>;

                  if (fullProgress === 0) return '0%';

                  if (currProgress === fullProgress) return '已完成';

                  return ((currProgress / fullProgress) * 100).toFixed(0) + '%';
                },
              },
              {
                title: '上传失败数',
                width: 60,
                dataIndex: 'failCount',
                render: (failCount) => failCount + '个',
              },
              {
                title: '操作',
                width: 60,
                render: (status, record) => {
                  if (record.status !== 1 && !record.downloadUrl) return '-';
                  return (
                    <a href={record.downloadUrl} rel="noreferrer">
                      下载
                    </a>
                  );
                },
              },
            ]}
          />
        </div>
      </div>
    </Modal>
  );
});

function AddTypes({ value, onChange }) {
  return (
    <Space>
      <CommonLog>
        <AddTypeBtn checked={value === 1} onClick={() => onChange(1)} clstag="yx_center_hzcp_1678258944439|31">
          手动上传
        </AddTypeBtn>
      </CommonLog>
      {/* <AddTypeBtn checked={value === 2} onClick={() => onChange(2)}>
        规则选品
      </AddTypeBtn> */}
    </Space>
  );
}

function AddTypeBtn({ children, checked, onClick, clstag }) {
  const classlist = classnames({ addtypechecked: checked }, 'add-type-btn');
  return (
    <CommonLog>
      <div onClick={onClick} className={classlist} clstag={clstag}>
        {children}
      </div>
    </CommonLog>
  );
}
